import {NotificationComponent} from "./notification.component";

export default NotificationComponent